import { BrandAvatar } from "@faire/deprecated-retailer-visitor-shared/components/BrandAvatar";
import { handleGenerateProductLinkProps } from "@faire/deprecated-retailer-visitor-shared/components/Carousel/utils";
import { Context } from "@faire/deprecated-retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Context";
import { productClickForSearchPageParametersILeanProductTileAdapter } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useOnProductClickForSearchPage";
import { ILeanProductTile } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/MarketplaceProduct/LeanProtos/ILeanProductTile";
import { ProductImage } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ProductImage";
import { useProductTileClickImpressions } from "@faire/deprecated-retailer-visitor-shared/hooks/ProductTileImpression/useProductTileClickImpressions";
import {
  SignUpElement,
  useTrackSignupModalOpenClick,
} from "@faire/deprecated-retailer-visitor-shared/lib/popSignUp";
import { SignUpType } from "@faire/deprecated-retailer-visitor-shared/lib/popSignUp";
import { brandPage } from "@faire/deprecated-retailer-visitor-shared/paths";
import { getUser } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getUser";
import { Column, Row } from "@faire/web/slate/Layout";
import { Typography } from "@faire/web/slate/Typography";
import { useEffectEvent } from "@faire/web/ui/hooks/useEffectEvent";
import { NoTranslate } from "@faire/web/ui/lib/localization";
import { Link } from "@faire/web/ui/LinkAnchor";
import React from "react";
import { useLocation } from "react-router-dom";

const BrandAvatarAndName = ({
  brand,
  handleOnBrandClick,
}: {
  brand: ILeanProductTile.IBrand | undefined;
  handleOnBrandClick: (
    brand: ILeanProductTile.IBrand | undefined
  ) => () => void;
}) => {
  if (!brand) {
    return null;
  }
  return (
    <Link
      to={brandPage(brand?.token ?? "")}
      onClick={handleOnBrandClick(brand)}
    >
      <Row gap="1x">
        <BrandAvatar
          size={{
            mobileAndAbove: "xx-small",
          }}
          image={brand?.profile_image}
          isTopShop={brand?.is_top_shop}
        />
        <Typography variant="paragraphSansRegular" maxLines={1}>
          <NoTranslate>{brand?.name}</NoTranslate>
        </Typography>
      </Row>
    </Link>
  );
};

export const SmallProductTile: React.FC<{
  product: ILeanProductTile;
  brand: ILeanProductTile.IBrand;
}> = ({ product, brand }) => {
  const location = useLocation();
  const user = getUser();
  const { layoutElement, requestId, onItemClick } = React.useContext(Context);
  const recordSignUpModalOpenClickEvent = useTrackSignupModalOpenClick();
  const {
    recordProductTileClickEvent,
    recordProductTileMiddleClickEvent,
    recordProductTileRightClickEvent,
    recordBrandNameClickEvent,
  } = useProductTileClickImpressions(
    productClickForSearchPageParametersILeanProductTileAdapter(product),
    brand?.token
  );
  const handleOnAuxClick = useEffectEvent(
    (event: React.MouseEvent<HTMLElement>) => {
      if (event.button === 1) {
        recordProductTileMiddleClickEvent();
      } else if (event.button === 2) {
        recordProductTileRightClickEvent();
      }
    }
  );
  const handleOnProductClick =
    (product: ILeanProductTile | undefined) => () => {
      recordProductTileClickEvent();
      onItemClick?.(
        layoutElement.on_click_event_name ?? "",
        requestId,
        product?.product?.token ?? ""
      );

      recordSignUpModalOpenClickEvent(
        SignUpType.PRODUCT,
        SignUpElement.PRODUCT_GRID,
        `logged_out_product_tile`
      );
    };

  const handleOnBrandClick =
    (brand: ILeanProductTile.IBrand | undefined) => () => {
      recordBrandNameClickEvent();
      onItemClick?.(
        layoutElement.on_click_event_name ?? "",
        requestId,
        brand?.token ?? ""
      );
    };
  return (
    <Column gap={12}>
      <Link
        to={
          handleGenerateProductLinkProps(product, location, user)()
            ?.productUrl ?? ""
        }
        onClick={handleOnProductClick(product)}
        onAuxClick={handleOnAuxClick}
      >
        <ProductImage image={product.best_image} />
      </Link>
      <BrandAvatarAndName
        brand={brand}
        handleOnBrandClick={handleOnBrandClick}
      />
    </Column>
  );
};
